import { Component, OnInit, ViewChild } from '@angular/core';
import { RightSideDrawerService } from '../right-side-drawer.service';
import { SessionService } from '../../session-service/session.service';
import { DefineActivitiesService } from '../../../data-analysis-summary/define-activities/define-activities.service';
import { encodeText } from 'src/app/shared/lib/custom-tools';
import { FormGroup, FormBuilder, Validators, AbstractControl, FormControl } from '@angular/forms';
import { Activity } from '../../models/ep-activity.model';
import { ToastrService } from '@kpmg-tax/ui';
import { API_URL } from '../../constants/apiurl-constants';
import { BaseResponse } from '../../models/base-response.model';
import { Messages } from '../../constants/messages';
import { Observable, debounceTime, distinctUntilChanged, switchMap, of, Subject, combineLatest, tap } from 'rxjs';
import { MasterActivities } from '../../models/master-activity/master-activities.model';
import { MasterActivitiesService } from 'src/app/admin/master-activities/master.activities.service';
import { ActivitySubTypeEnum, ActivityTypeEnum } from '../../constants/activity-type.enum';
import { ACTIVITYSUBTYPES, ACTIVITY_CONSTANTS, ACTIVITY_SUBTYPE_CONSTANTS, APP_CONSTANTS } from '../../constants/app-constants';
import { CustomDropDown } from '../../models/custom-dropdown.model';
import { CustomDropdownComponent } from '../../custom-dropdown/custom-dropdown.component';
import { WhiteSpaceValidator } from 'src/app/core/validators/whitespace-validator';

const activities = [
  { activityType: ActivityTypeEnum.Activity, activityTypeName: ACTIVITY_CONSTANTS.ACTIVITY, isSelected: true },
  { activityType: ActivityTypeEnum.NQA, activityTypeName: ACTIVITY_CONSTANTS.NQA, isSelected: false },
  { activityType: ActivityTypeEnum.NWT, activityTypeName: ACTIVITY_CONSTANTS.NWT, isSelected: false }
];

@Component({
  selector: 'ep-add-activity',
  templateUrl: './ep-add-activity.component.html',
  styleUrls: ['./ep-add-activity.component.scss'],
})
export class EpAddActivityComponent implements OnInit {
  targetForm: FormGroup;
  validate: string = '';
  exists: string = '';
  _EngagementActivity: any;
  isDisabled: boolean = false;
  isActivityValue: boolean = false;
  activityTypes = JSON.parse(JSON.stringify(activities));
  activityGroupList: MasterActivities[] = [];
  isInvalidQualifiedPercentage = false;
  activityGroupObserver: Subject<string> = new Subject<string>();
  engagementId: number;
  dropdownOptions: CustomDropDown[] = [];
  showActivitySubTypeValidation: boolean;
  selectedActivitySubType:string = '';
  selectedActivitySubTypeId:number;
  @ViewChild(CustomDropdownComponent) private customDropdownComponent!: CustomDropdownComponent;
  isActivitySubTypeSelected:boolean = false;
  disableActivitySubtype:boolean = false;
  isActivityGroupSelected: boolean = false;

  constructor(private _masterActivitiesService: MasterActivitiesService,
    public rightSideDrawerService: RightSideDrawerService,
    public activitiesService: DefineActivitiesService,
    public sessionService: SessionService,
    public _toasterService: ToastrService,
    public formBuilder: FormBuilder,
  ) { 
    this.dropdownOptions = this.getActivtiySubTypeOptions();
  }
  
  // reset form content
  public resetRightSideDrawerData = () => {
    this.targetForm.reset();
  }

  ngOnInit() {
    this.engagementId = parseInt(this.sessionService.getSession('engagementId'));
    this._EngagementActivity = this.rightSideDrawerService.multipleRowAddData;
    if ((this.rightSideDrawerService.singleRowEditData == null) || (typeof this.rightSideDrawerService.singleRowEditData === 'undefined')) {
      this.resetRightSideDrawerDataAdd();
    }
    this.targetForm = this.formBuilder.group({
      qpercentage: ['100', [
        Validators.required,
        Validators.pattern('^[0-9]+(.[0-9]{1,2})?$'),
        Validators.min(0),
        Validators.max(100),
      ]],
      name: ['', [
        Validators.required,
        Validators.maxLength(100),WhiteSpaceValidator.cannotContainSpace,
        this.UniqueActivityNameAdd(this._EngagementActivity),
      ]],
      activityGroup: ['', [Validators.required, Validators.maxLength(100),WhiteSpaceValidator.cannotContainSpace]],
      description: ['', [Validators.maxLength(500)]],
    });
    this.getAllActivities(this.engagementId);
  }

  selectActivityType(activity: { activityType: ActivityTypeEnum, activityTypeName: string, isSelected: boolean }) {
    this.activityTypes.map(item => {
      item.isSelected = item.activityTypeName === activity.activityTypeName ? true : false;
    });
    if (activity.activityType === ActivityTypeEnum.NQA || activity.activityType === ActivityTypeEnum.NWT
      || activity.activityTypeName === ACTIVITY_SUBTYPE_CONSTANTS.NQ41Q174
    ) {
      this.targetForm.controls['activityGroup'].patchValue(activity.activityTypeName);
      this.targetForm.controls['qpercentage'].patchValue(0);
      this.targetForm.controls['activityGroup'].disable();
      this.targetForm.controls['qpercentage'].disable();
    } else {
      this.targetForm.controls['activityGroup'].reset()
      this.targetForm.controls['qpercentage'].patchValue(100);
      this.targetForm.controls['activityGroup'].enable()
      this.targetForm.controls['qpercentage'].enable();
    }
    this.isInvalidQualifiedPercentage = this.validateInput('qpercentage');
  }

  // reference to form fields
  get f() {
    return this.targetForm?.controls;
  }

  UniqueActivityNameAdd(activityList: any) {
    return (control: AbstractControl): { [key: string]: any } => {
      const actName = this.trim(control.value).toUpperCase();

      if (
        activityList.find(x => x.name.toUpperCase() === actName) !== undefined
      ) {
        return { UniqueAName: true };
      }
      return null;
    };
  }

  trim(x) {
    return x ? x.replace(/^\s+|\s+$/gm, '') : '';
  }

  trimSpecialChar(ctrl: any) {
    this.targetForm.controls[ctrl].setValue(
      this.targetForm.get(ctrl).value.replace(/[^a-zA-Z0-9-()._#!$%^+=&,*@/ ]/g, ''),
    );
  }

  public resetRightSideDrawerDataAdd = () => {
    this.targetForm = this.formBuilder.group({
      qpercentage: [
        '100',
        [Validators.required, Validators.pattern('^[1-9][0-9]?$|^100$')],
      ],
      name: [
        '',
        [
          Validators.required,
          Validators.maxLength(100),WhiteSpaceValidator.cannotContainSpace,
          this.UniqueActivityNameAdd(this._EngagementActivity),
        ],
      ],
      activityGroup: ['', Validators.required,WhiteSpaceValidator.cannotContainSpace],
      description: ['', [Validators.maxLength(500)]],
    });
  }

  UniqueActivityNameUpdate(activityList: any, row: any) {
    return (control: AbstractControl): { [key: string]: any } => {
      const actName = this.trim(control.value).toUpperCase();
      if (
        row.name.toUpperCase() !== actName &&
        activityList.find(x => x.name.toUpperCase() === actName) !== undefined
      ) {
        return { UniqueAName: true };
      }
      return null;
    };
  }

  public resetRightSideDrawerDataUpdate = () => {
    this.targetForm = new FormGroup({
      name: new FormControl(
        this.rightSideDrawerService.singleRowEditData.name,
        [
          Validators.required,
          this.UniqueActivityNameUpdate(
            this._EngagementActivity,
            this.rightSideDrawerService.singleRowEditData,
          ),
        ],
      ),
      activityGroup: new FormControl(
        this.rightSideDrawerService.singleRowEditData.activityGroup,
        [Validators.required],
      ),
      qpercentage: new FormControl(
        this.rightSideDrawerService.singleRowEditData.qPercentage,
        [Validators.required, Validators.pattern('^[1-9][0-9]?$|^100$')],
      ),
    });
  }

  addActivity = () => {
    this.isDisabled = true;
    let activity: any = {
      name: encodeText(this.targetForm.get('name').value),
      desc: encodeText(this.targetForm.get('description').value),
      activityGroup: encodeText(this.getActivityGroupFormValue()),
      qPercentage: this.targetForm.get('qpercentage').value,
      engagementId: this.sessionService.getSession('engagementId'),
      activityType: this.selectedActivitySubTypeId,
      subTypeName: this.selectedActivitySubType
    };

    activity = this.sessionService.removeNullEmptyValues(activity);
    this.sessionService.apiUrlPost(API_URL.ADDENGAGEMENTACTIVITY, activity).subscribe((data: BaseResponse) => {
      if (data.success) {
        this.activitiesService.refreshTable();
        let tabledata: Array<Activity> = this.activitiesService
          .tableDataFiltered;
        data.result.qPercentage = data.result.qPercentage + '%';
        tabledata.unshift(data.result);
        this.activitiesService.tableDataFiltered = [...tabledata];
      }
      this.rightSideDrawerService.closeRightSideDrawer();
      this._toasterService.setSuccessMessage(Messages.Activity.AddActivitySuccess);
    });
  }

  private getActivityGroupFormValue(): string {
    var rawFormValue = this.targetForm.get('activityGroup').value;
    if (rawFormValue == null || rawFormValue == undefined)
      return "";
    if (rawFormValue.activityGroup == null || rawFormValue.activityGroup == undefined)
      return rawFormValue.trim();
    return rawFormValue.activityGroup.trim();
  }

  inputChanged() {
    let activity: any = {
      name: this.targetForm.get('name').value,
      description: this.targetForm.get('description').value,
      percentage: this.targetForm.get('qpercentage').value + '%',
    };
    if (activity.name != null || activity.description != null || activity.qpercentage != null) {
      this.rightSideDrawerService.setMandatoryField(true, 'Add Activity');
    } else {
      this.rightSideDrawerService.setMandatoryField(false, '');
    }
    this.isInvalidQualifiedPercentage = this.validateInput('qpercentage');
  }

  validateInput(formControl: string): boolean {
    let control = this.targetForm.controls[formControl];
    return control && (control.errors != null || control.invalid) ? true : false;
  }

  public buildFrom(activity) {
    this.rightSideDrawerService.multipleRowAddData = activity;
  }

  ActivityValueChange() {
    let name = this.targetForm.get('name').value;
    if (name && name.trim().length > 0) {
      this.isActivityValue = true;
    } else {
      this.isActivityValue = false;
    }
  }

  getAllActivities(engagementId: number): void {
    this.activityGroupList = [];
    let masterActivities$ = this._masterActivitiesService.GetActivityGroup() as Observable<any>;
    let engagementActivities$ = this.activitiesService.GetEngagementActivities(engagementId);
    combineLatest([masterActivities$, engagementActivities$]).pipe(tap(([masterActivities, engagementActivities]) => {
      this.activityGroupList = masterActivities?.result;
      engagementActivities?.result.forEach(item => {
        if (item.activityGroup?.trim().length > 0 && this.activityGroupList.findIndex(x => x.activityGroup.toLowerCase() === item.activityGroup?.toLowerCase()) < 0) {
          this.activityGroupList.push(item);
        }
      });
    })).subscribe();
  }

  searchActivityGroup(term: any): Observable<any> {
    if (this.activityGroupList) {
      return of(this.activityGroupList.filter((item: any) =>
        item.activityGroup.toLowerCase().includes(term.toLowerCase()) 
      && item.activityGroup.toLowerCase() != ACTIVITY_CONSTANTS.NQA.toLowerCase() 
      && item.activityGroup.toLowerCase() != ACTIVITY_CONSTANTS.NWT.toLowerCase() 
      && item.activityGroup.toLowerCase() !== 'non-working time'),
      );
    } else {
      return of([]);
    }
  }

  activityGroupFormatter = (result: any) =>
    typeof result.activityGroup === 'undefined' ? result : result.activityGroup;

  filterActivityGroup = (searchPhrase$: Observable<any>) =>
    searchPhrase$.pipe(debounceTime(150), distinctUntilChanged(), switchMap(term => {
      return this.searchActivityGroup(term).pipe(switchMap(data => {
        return of(data);
      }));
    }))

  activityGroupValidationDelayer(activityGroup: string) {
    if (this.activityGroupObserver.observers.length === 0) {
      this.activityGroupObserver
        .pipe(debounceTime(200))
        .subscribe(() => {
          this.activityGroupValidation();
        });
    }

    this.activityGroupObserver.next(activityGroup);
  }

  // 1. Checks if the user entered in a non-qualified activity but did not hit the "Non-Qualified Activity" switch.
  // 2. Checks if the user entry matches a previous activity group, but in a different case. If so, changes to that.
  activityGroupValidation() {
    let activityGroupInput = this.targetForm.get('activityGroup').value;
    let activityGrounName;
    if (activityGroupInput.activityGroup === undefined) {
      activityGrounName = activityGroupInput;
    } else {
      activityGrounName = activityGroupInput.activityGroup;
    }

    if (activityGrounName.toUpperCase() == 'NQA') {
      this.targetForm.patchValue({ activityGroup: 'NQA', qpercentage: 0 });
      this.targetForm.controls['activityGroup'].disable();
      this.targetForm.controls['qpercentage'].disable();
    } else {
      for (let activity of this.activityGroupList) {
        if (activityGrounName.toLowerCase() == activity.activityGroup.toLowerCase()) {
          this.targetForm.patchValue({ activityGroup: activity.activityGroup });
          break;
        }
      }
    }

    if (activityGrounName.toLowerCase() == APP_CONSTANTS.NWT.toLowerCase()) {
      this.targetForm.patchValue({ activityGroup: APP_CONSTANTS.NWT, qpercentage: 0 });
      this.targetForm.controls['activityGroup'].disable();
      this.targetForm.controls['qpercentage'].disable();
    }

    this.activityTypes.forEach(option => {
      if (activityGrounName.toString().toLowerCase() === APP_CONSTANTS.NQA.toLowerCase()) {
        option.isSelected = option.activityTypeName.toLowerCase() === APP_CONSTANTS.NQA.toLowerCase() ? true : false;
      } else if (activityGrounName.toString().toLowerCase() === APP_CONSTANTS.NWT.toLowerCase()) {
        option.isSelected = option.activityTypeName.toLowerCase() === APP_CONSTANTS.NWT.toLowerCase() ? true : false;
      }
    });
  }

  private getActivtiySubTypeOptions(): CustomDropDown[] {
    const activitySubTypeOptions = ACTIVITYSUBTYPES.filter(item => item.activitySubType !== ActivitySubTypeEnum['Non-working Time']);
    const options: CustomDropDown[] = [{ id: 0, value: '', isDisabled: false }];
    activitySubTypeOptions.forEach((item, index) => {
      options.push({ id: item.activitySubType, value: item.activitySubTypeName, isDisabled: false });
    });
    return options;
  }

  onActivitySubTypeSelected(optionSelected: CustomDropDown): void {
    if (optionSelected === null) {
      this.showActivitySubTypeValidation = this.selectedActivitySubType === '' ? true : false;
      this.customDropdownComponent.showError = this.selectedActivitySubType === '' ? true : false;
    } else {
      this.showActivitySubTypeValidation = false;
      this.customDropdownComponent.showError = false;
      this.selectedActivitySubType = optionSelected.value;
      this.selectedActivitySubTypeId = optionSelected.id;
      if(optionSelected.id>0 || optionSelected.value.toLowerCase() === ACTIVITY_SUBTYPE_CONSTANTS.NQ41Q174.toLowerCase()){
        this.targetForm.patchValue({activityGroup: optionSelected.value, qpercentage: 0 });
        this.targetForm.controls['activityGroup'].disable();
        this.targetForm.controls['qpercentage'].disable();
      }else{    
        this.targetForm.patchValue({ activityGroup: '', qpercentage: 100 });    
        this.targetForm.controls['activityGroup'].enable();
        this.targetForm.controls['qpercentage'].enable();
      }
    }
    this.isActivitySubTypeSelected = !this.showActivitySubTypeValidation;
  }

  isBtnDisabled() {
    if (!this.targetForm.valid) {
      return true;
    }
    else if (!this.isActivitySubTypeSelected) {
      return true;
    } 
    else if (this.isDisabled) {
      return true;
    } else {
      return false;
    }
  }
}
